import React from 'react';
import { Dropdown, DropdownItem, DropdownMenu } from 'reactstrap';
import { useQueueContentChatContext } from '../../../../../../hooks/useQueueContentChat';

export const FilterStatusOptions = ({
  open,
  openDropDown,
  handlerFilter,
  children
}) => {
  const { filters } = useQueueContentChatContext();

  const handleClick = (option, type, e) => {
    e.stopPropagation();
    handlerFilter(option, type);
  };

  return (
    <Dropdown
      direction="right"
      style={{
        display: 'flex',
        border: 'none',
        margin: 0,
        padding: 0,
        width: '100%',
        height: '100%',
        color: 'black'
      }}
      onMouseEnter={() => openDropDown(true)}
      onMouseLeave={() => openDropDown(false)}
      isOpen={open}
      toggle={() => openDropDown(!open)}
    >
      {children}
      <DropdownMenu
        style={{
          marginLeft: '-10px'
        }}
        className="DropdownMenu"
      >
        <DropdownItem
          toggle={false}
          onClick={(e) => handleClick('ALL', 'STATUS', e)}
        >
          <input
            id={`dropdownItemSTATUS_ALL`}
            type="checkbox"
            checked={filters['STATUS'].length === 0}
            onChange={(e) => handleClick('ALL', 'STATUS', e)}
            style={{ marginRight: '5px' }}
          />
          Todas
        </DropdownItem>
        <DropdownItem divider />
        <DropdownItem
          toggle={false}
          onClick={(e) => handleClick('READ', 'STATUS', e)}
        >
          <input
            id={`dropdownItemREAD`}
            type="checkbox"
            checked={filters['STATUS'].includes('READ')}
            onChange={(e) => handleClick('READ', 'STATUS', e)}
            style={{ marginRight: '5px' }}
          />
          Mensagens Lidas
        </DropdownItem>
        <DropdownItem
          toggle={false}
          onClick={(e) => handleClick('UNREAD', 'STATUS', e)}
        >
          <input
            id={`dropdownItemUNREAD`}
            type="checkbox"
            checked={filters['STATUS'].includes('UNREAD')}
            onChange={(e) => handleClick('UNREAD', 'STATUS', e)}
            style={{ marginRight: '5px' }}
          />
          Mensagens Não Lidas
        </DropdownItem>
        <DropdownItem
          toggle={false}
          onClick={(e) => handleClick('IN_ATTENDANCE', 'STATUS', e)}
        >
          <input
            id={`dropdownItemIN_ATTENDANCE`}
            type="checkbox"
            checked={filters['STATUS'].includes('IN_ATTENDANCE')}
            onChange={(e) => handleClick('IN_ATTENDANCE', 'STATUS', e)}
            style={{ marginRight: '5px' }}
          />
          Responder
        </DropdownItem>
        <DropdownItem
          toggle={false}
          onClick={(e) => handleClick('WAITING_FOR_ANSWER', 'STATUS', e)}
        >
          <input
            id={`dropdownItemWAITING_FOR_ANSWER`}
            type="checkbox"
            checked={filters['STATUS'].includes('WAITING_FOR_ANSWER')}
            onChange={(e) => handleClick('WAITING_FOR_ANSWER', 'STATUS', e)}
            style={{ marginRight: '5px' }}
          />
          Aguardando Resposta
        </DropdownItem>
      </DropdownMenu>
    </Dropdown>
  );
};
